import { render, staticRenderFns } from "./BasePopUp.vue?vue&type=template&id=836fda7e&scoped=true"
import script from "./BasePopUp.vue?vue&type=script&lang=js"
export * from "./BasePopUp.vue?vue&type=script&lang=js"
import style0 from "./BasePopUp.vue?vue&type=style&index=0&id=836fda7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836fda7e",
  null
  
)

export default component.exports